<template>
  <div class="post type-post hentry" id="post-2">
    <h2>
      <router-link
        to="/2011/01/sausio-13-osios-lietuvos-pilieciu-zygdarbis/"
        >Sausio 13-osios Lietuvos piliečių žygdarbis</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Sausio</span><span class="date_nr">13</span>
    </div>
    <div class="entry">
      <p>
        <strong
          ><span
            style="line-height: 70%; display: block; font-style: italic; padding-top: 10px;"
            >Gediminas Vagnorius,</span
          ></strong
        >
      </p>
      <p>
        <span style="line-height: 70%; display: block; font-style: italic;"
          >Ekspremjeras,</span
        >
      </p>
      <p>
        <span style="line-height: 70%; display: block; font-style: italic;"
          >Krikščionių partijos pirmininkas</span
        ><br />
        Prieš 20 metų Lietuvą nuo žiaurios agresijos apgynė drąsų istorinį
        žygdarbį atlikę paprasti piliečiai, kurie savo krūtinėmis užtvėrė kelią
        sovietų tankams.
      </p>
      <p>
        <img
          class="alignleft"
          title="black ribbon"
          style="position:absolute;margin: -140px 0 0 -50px;"
          src="/assets/80px-Black_ribbon.png"
          alt="black ribbon"
          width="40px"
          height="60px"
        />Tą tragišką sausio naktį sužvėrėjusios smogikų kariuomenės vadai ir M.
        Gorbačiovas išsigando ne Lietuvos ar Vakarų valstybių valdžios, jie
        išsigando Tėvynę ginti suskubusių dešimčių tūkstančių patriotų.
      </p>
      <p>
        <img
          class="alignright"
          style="padding: 10px;"
          title="Gediminas Vagnorius"
          src="/assets/vagnorius_gediminas.jpg"
          alt="Gediminas Vagnorius"
          width="136"
          height="195"
        />Okupacinė kariuomenė suvokė, kad Lietuvos žmonių įbauginti nepavyko ir
        jie nesitrauks, o tai gresia masinėmis taikių piliečių žudynėmis, už
        kurias teks asmeninė atsakomybė.
      </p>
      <p>
        Tai patvirtino vėliau gautos sovietų kariškių pokalbių išklotinės – po
        kraupaus televizijos bokšto šturmo Maskva nebeišdrįso prie Parlamento
        įstrigusiems šarvuočiams duoti įsakymo jį šturmuoti per tūkstantinę
        minią.
      </p>
      <p>
        Tą sovietų karinės agresijos naktį man likimas lėmė pareigą stoti prie
        Vyriausybės vairo ir tiesiogiai patirti Kremliaus karinį planą užgrobti
        valdžią Lietuvoje ir dar kartą ją okupuoti.
      </p>
      <p>
        Sausio 13 dienos įvykiai nebuvo spontaniški, kaip vėliau bandė aiškinti
        M. Gorbačiovas. Sovietų Sąjunga veikė pagal gerai iš anksto parengtos
        karinės operacijos planą, kuris apėmė demokratinio pasaulio reakcijos
        slopinimą, naujų specialių smogiamųjų karinių dalinių dislokavimą
        Lietuvoje, gyventojų socialinio nepasitenkinimo išprovokavimą ir net
        pasirengimą marionetinės valdžios sudarymui. Jau buvo parinktas ir
        „sukalbamas“ AT pirmininkas ir promaskvietiškos Vyriausybės vadovai,
        kurie gerai žinojo apie rengiamą karinį puolimą.
      </p>
      <p>
        Neatsitiktinai ginkluotai agresijai buvo pasirinktas karinių įvykių
        Persijos įlankoje laikotarpis, kai JAV ir jų artimieji sąjungininkai
        buvo priversti nuolaidžiauti Sovietų Sąjungai. Tuomet apie ypatingą
        pavojų Lietuvai dar 1990 metų gruodžio 22 d. privačiai įspėjo tuometinis
        JAV konsulas Leningrade. Jis patarė ypač saugotis galimo visuomenės
        socialinių nepasitenkinimų išprovokavimo. Todėl skubiai inicijavome
        Aukščiausios Tarybos nutarimą, kuriuo buvo kategoriškai uždrausta
        tuometinei Respublikos Vyriausybei keleriopai padidinti pagrindinių
        maisto produktų kainas.
      </p>
      <p>
        Lieka tik stebėtis, kaip pirmosios Vyriausybės vadovams pavyko
        suklaidinti daugumą&nbsp; Kabineto narių be realaus socialinio
        kompensavimo keturgubai pakelti kainas, taip pat kaip aiškiai matomos
        karinės agresijos išvakarėse toks akivaizdžiai &nbsp;provokacinis
        projektas pateko į Vyriausybę?
      </p>
      <p>
        Apie galingą sovietinių jėgų veikimą Respublikos politinėje erdvėje
        liudija ir faktas, kad tuometinės Vyriausybės vadovai jau žinodami, kad
        kainų pakėlimo pretekstu sausio 8 d. jedinstvininkų ir perrengtų
        sovietinių kariškių riaušininkų būriai pasirengę veržtis į Parlamento
        rūmus, išdrįso nepaklusti AT draudimui keleriopai kelti kainas.
      </p>
      <p>
        AT Prezidiumas (kuriame tuomet man teko kuruoti ekonominius klausimus)
        išvakarėse sužinojęs, kad K. Prunskienės vadovaujama Vyriausybė
        keleriopai sukels maisto produktų kainas ir riaušininkai kitą dieną
        šturmuos Seimo pastatą, jau negalėjo nieko pakeisti.
      </p>
      <p>
        Kaip ir tikėtasi, sausio 8 d. riaušininkai puolė ne Vyriausybę, kuri
        sukėlė kainas, bet Aukščiausiąją Tarybą, kuri buvo uždraudusi tai
        daryti… Valstybingumo simbolį – Parlamentą – tą dieną padėjo apginti
        paprasti piliečiai, nustūmę nuo pastato jedinstvininkus.
      </p>
      <p>
        Tą pačią dieną &nbsp;Aukščiausioji Taryba&nbsp; atstatydino&nbsp;
        pirmąją Lietuvos Respublikos Vyriausybę ir atšaukė jos sprendimą
        keleriopai padidinti maisto produktų kainas. Parlamentas pasielgė
        ryžtingai ir išmintingai, &nbsp;atimdamas iš promaskvietiškų jėgų
        socialinį pretekstą platesnėms antivalstybinėms riaušėms organizuoti.
        Baugu net įsivaizduoti, kaip sovietų propoganda sausio 13-osios karinę
        agresiją būtų pateikę, kaip pilietinį nepasitenkinimą. Ji būtų
        vaizduojama kaip „darbo liaudies“ reikalavimu įvykdytas
        nekompetentingos, pilietines riaušes sukėlusios Lietuvos valdžios
        pakeitimas.
      </p>
      <p>
        Sovietinio Kremliaus kruopščiai parengtą žiaurų karinį valdžios
        užgrobimo planą sužlugdė netikėtai didžiulis taikių piliečių
        pasipriešinimas. Net ir šiandien mes dar iki galo nesuvokiame, kaip tą
        naktį tik dėka tikro stebuklo, kurį sukūrė šimtai tūkstančių drąsių
        paprastų žmonių, pavyko sustabdyti gerai organizuotų, sužvėrėjusių
        kariškių puolimą, kurio Kremlius vėliau nebeišdrįso pakartoti. Ta naktis
        galėjo iš esmės pakeisti geopolitinių permainų smaigalyje buvusios
        Lietuvos ir kartu kaimyninių Respublikų likimą, dar ilgam pratęsti
        Sovietų imperijos egzistavimą.
      </p>
      <p>
        Nepavykus užgrobti valdžios sausio 13 – osios naktį,&nbsp; Sovietų
        Sąjungos lyderiai, žinoma, nenuleido rankų. Jie siekė sustiprinti
        okupacinį rėžimą, panaudojant&nbsp; Lietuvoje dislokuotos kariuomenės ir
        specialios milicijos dalinius, griaunant šalies ekonominius ir
        finansinius pamatus.
      </p>
      <p>
        Atsilaikiusi prieš Sausio agresiją, 1991 metais Lietuva, dar okupacinei
        kariuomenei nepasitraukus, įvykdė neįtikėtiną uždavinį – sukūrė
        praktinius Nepriklausomos valstybės valdymo svertus ir įvykdė esminę
        ekonominę reformą, be kurios nebūtume atlaikę Kremliaus vykdytos
        totalinės ūkio blokados.
      </p>
      <p>
        Dar iki rugpjūčio pučo perėmėme sovietines įmones, įskaitant karines
        gamyklas, atsiskyrėme nuo Maskvos mokesčių, laipsniškai atpalaidavome
        rinkos kainas, įsivedėme pirmuosius pinigus. Svarbiausia, jog šiuo
        pavojingiausiu laikotarpiu pavyko išvengti žmonių pragyvenimo smukimo ir
        menkiausių socialinių protestų, kuriais okupacinis rėžimas neišvengiamai
        būtų pasinaudojęs. Nepaisant Sovietų Sąjungos ekonominių ir finansinių
        blokadų bei sunkių vidaus ūkio reformų,&nbsp; Lietuva 1991 metais
        pirmuosius savarankiškus finansinius metus užbaigė turėdama palyginus
        didžiulį valstybės biudžeto perviršį.
      </p>
      <p>
        Ar dabar įsivaizduojame valstybę, kurioje mokesčiai surenkami beveik
        savanoriškais pagrindais, o skaudžiausia bausmė nusižengusiam politikui,
        valdininkui ar įmonininkui – jo negerų darbų paviešinimas ir pilietinis
        pasmerkimas. Tokia buvo 1991 metų Lietuva, kuri iki Nepriklausomybės
        tarptautinio pripažinimo beveik neturėjo valstybėms būdingo represinio
        aparato.
      </p>
      <p>
        Jei būtume iki šiol išsaugoję 1991 metų pilietinio reiklumo dvasią,
        šiandien Lietuva jau būtų klestinti Šiaurės Europos valstybė.
      </p>
    </div>
  </div>
</template>
